import { render, staticRenderFns } from "./StreamingMessage.vue?vue&type=template&id=43c0d920&scoped=true"
import script from "./StreamingMessage.vue?vue&type=script&lang=js"
export * from "./StreamingMessage.vue?vue&type=script&lang=js"
import style0 from "./StreamingMessage.vue?vue&type=style&index=0&id=43c0d920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c0d920",
  null
  
)

export default component.exports